import React, { useRef } from 'react';
import composeRefs from '@seznam/compose-react-refs';
import { Tooltip } from '@pushwoosh/kit-tooltip';
import { FieldBoxContainer, FieldBoxHeader, FieldBoxOptionalText, FieldBoxContent, FieldBoxFooter } from './field-box.styles';
export function FieldBox(props) {
  const {
    boxRef,
    contentRef,
    title,
    isOptional,
    isLoading,
    helpText,
    helpTextPosition,
    isShowedHelpText,
    footer,
    children,
    ...rest
  } = props;
  const isHelpTextRelativeOnBox = helpTextPosition === 'top-start' || helpTextPosition === 'bottom-start';
  const internalBoxRef = useRef(null);
  const internalContentRef = useRef(null);
  return React.createElement(React.Fragment, null, React.createElement(FieldBoxContainer, {
    ...rest,
    ref: composeRefs(internalBoxRef, boxRef),
    isLoading: isLoading
  }, title && React.createElement(FieldBoxHeader, null, React.createElement("span", null, title), isOptional && React.createElement(FieldBoxOptionalText, null, "\u00A0(optional)")), React.createElement(FieldBoxContent, {
    ref: composeRefs(internalContentRef, contentRef)
  }, children), footer && React.createElement(FieldBoxFooter, null, footer)), helpText && React.createElement(Tooltip, {
    content: helpText,
    position: helpTextPosition,
    reference: isHelpTextRelativeOnBox ? internalBoxRef : internalContentRef,
    isVisible: isShowedHelpText
  }));
}